import validate from "/builds/kassir/website/node_modules/nuxt/dist/pages/runtime/validate.js";
import _0_45open_45telemetry_45global from "/builds/kassir/website/widget/middleware/0.openTelemetry.global.ts";
import _3_45query_45guard_45global from "/builds/kassir/website/widget/middleware/3.queryGuard.global.ts";
export const globalMiddleware = [
  validate,
  _0_45open_45telemetry_45global,
  _3_45query_45guard_45global
]
export const namedMiddleware = {}